export default {
  path: '/employee',
  name: 'Employee',
  component: () => import('../views/layouts/Employee.layout.vue'),
  meta: {
    requiresAuth: true
  },
  children: [
    {
      path: 'search',
      name: 'EmployeeSearch',
      component: () =>
        import('../views/pages/Employee/EmployeeSearch.page.vue'),
      meta: {
        requiresAuth: true
      }
    }
  ]
}
